import { Template, TemplateRaw } from "frontend/interfaces/template";

export function parseTemplate(template: TemplateRaw): Template {
  return { ...template };
}
